/**
 * Questions the manage page answers.
 *
 * Kept beside the route's other content so the FAQ schema and the rendered
 * `<dl>` read one array. Each answer traced through the API:
 *  - `status: 'pending' | 'published'` — nothing publishes itself below Advanced
 *  - `BULK_REVIEW_ACTIONS = ['publish', 'unpublish', 'delete']`
 *  - reviews carry `tags`; widgets carry the tag ids they are limited to
 *  - `canReplyTo` is true only for `manual` and `via-reviewsjet` sources
 *  - `hasAutoPublish` / `hasAutoSync` are Advanced and above
 */
export const MANAGE_FAQS: { q: string; a: string }[] = [
  {
    q: 'Do imported reviews go straight onto my website?',
    a: 'No. Everything arrives unpublished and stays in your library until you publish it. On Advanced you can turn on auto-publish for reviews at or above a rating you choose, which is the only way anything reaches the site without you.',
  },
  {
    q: 'Can I hide a bad review?',
    a: 'You can choose not to publish it, and you can unpublish one that is already showing. What you cannot do is change it or remove it from Google — ReviewsJet reads your public reviews, it does not edit them, and the review stays where your customers found it.',
  },
  {
    q: 'Can I reply to reviews from ReviewsJet?',
    a: 'Only to reviews collected through ReviewsJet — through one of your own forms, or typed in by hand. A reply to a Google review has to be written in Google, because Google owns that thread and gives nobody else a way to post into it.',
  },
  {
    q: 'Can different pages show different reviews?',
    a: 'Yes. Tag your reviews, then limit a widget to a tag. The reviews beside your pricing can be a different set from the ones on your homepage, from the same library.',
  },
  {
    q: 'What happens when I unpublish a review?',
    a: 'It disappears from every widget showing it, usually within minutes, and stays in your library in case you change your mind. Nothing on your website needs editing.',
  },
];
